// extracted by mini-css-extract-plugin
module.exports = {"container":"_3SPLaF","title":"UVYmey mz-caption"};